export enum AppBannerKeys {
  KYC_APPROVAL = 'KYC_APPROVAL',
  LINK_WALLET = 'LINK_WALLET',
  ADD_NAME = 'ADD_NAME',
  REFERRAL_CODE = 'REFERRAL_CODE',
}
